export const PRIVACY_PATH = '/privacy/privacy-and-security-statement';
export const SECURITY_PATH = '/myaccount/security';
export const ADDRESS_PATH = '/myaccount/addresses';
export const DO_NOT_CALL = '/c/Do_Not_Call';

export const UPDATE_SUCCESS = 'Success! Your preferences have been updated.';
export const ALL_EMAIL_UNSUBSCRIBE_SUCCESS = ' has been successfully unsubscribed from all '
  + 'marketing emails.';
export const HOME_DEPOT_MARKETING_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to '
  + 'The Home Depot marketing list.';
export const HOME_DEPOT_MARKETING_UNSUBSCRIBE_SUCCESS = ' has been successfully '
  + 'unsubscribed from The Home Depot marketing list.';
export const LOCAL_AD_MARKETING_EMAIL_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to '
  + 'the Local Ad marketing list.';
export const LOCAL_AD_MARKETING_EMAIL_UNSUBSCRIBE_SUCCESS = ' has been successfully '
  + 'unsubscribed from the Local Ad marketing list.';
export const SPECIAL_BUY_MARKETING_EMAIL_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to '
  + 'the Daily Deals marketing list.';
export const SPECIAL_BUY_MARKETING_EMAIL_UNSUBSCRIBE_SUCCESS = ' has been successfully '
  + 'unsubscribed from the Daily Deals marketing list.';
export const PRO_MARKETING_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to the '
  + 'Pro Communications marketing list.';
export const PRO_MARKETING_UNSUBSCRIBE_SUCCESS = ' has been successfully unsubscribed '
  + 'from the Pro Communications marketing list.';
export const SMS_OPT_IN_SUCCESS = `Success! We’ve sent you a text message.
To confirm your request, please respond with a "Y"`;
export const ALL_SMS_UNSUBSCRIBE_SUCCESS = ' has been successfully unsubscribed from all '
  + 'marketing text messages.';
export const ALL_SMS_TELEMARKETING_UNSUBSCRIBE_SUCCESS = ' has been successfully opted out '
  + 'from all marketing text messages. You have also been added to The Home Depot’s Do Not Call List.';
export const ERROR_RETRIEVING_PREFERENCES = 'There was an issue when loading your preferences.'
  + ' Please refresh the page.';
export const ERROR_ALERT_TEXT = 'We\'re unable to process your request. Please try again later.';
export const NO_PHONE_TEXT = 'There is no phone number on this account. To subscribe to text messages, visit the ';
export const PENDING = 'P';
export const YES = 'Y';
export const NO = 'N';
export const ENG = 'ENG';
export const SPAN = 'SPAN';

const pageSource = 'MYACCOUNT_PREFERENCES';

export const DESKTOP = `${pageSource}_DESKTOP`;
export const MOBILE_APP = `${pageSource}_MOBILE_APP`;
export const MOBILE_BROWSER = `${pageSource}_MOBILE_BROWSER`;
export const TABLET = `${pageSource}_TABLET`;
export const OPTOUT_FEEDBACK_SUCCESS = 'Success! Your feedback has been recorded.';
export const OPTOUT_FEEDBACK_ERROR = 'Something went wrong. Your feedback has not been recorded.';

export const EMAIL_CONFIRMATION = 'EMAIL_CONFIRMATION';
export const SMS_CONFIRMATION = 'SMS_CONFIRMATION';

export const BENEFIT_TAGNAME = 'AMBenefit';
export const BENEFIT_VALUE = 'Confirmed';

export const ERECEIPT_SUBSCRIBE_SUCCESS = ' has been successfully subscribed to receive eReceipt emails.';
export const ERECEIPT_UNSUBSCRIBE_SUCCESS = ' has been successfully unsubscribed from receiving eReceipt emails.';
export const ERECEIPTS = 'ERECEIPTS';
export const MARKETING_PREF = 'MARKETING_UPDATES';

export const SURVEY_EMAIL_UNSUBSCRIBE_SUCCESS = ' preferences has been updated and is unsubscribed from Surveys.';
export const SURVEY_EMAIL_SUBSCRIBE_SUCCESS = ' preferences has been updated and is subscribed to Surveys.';
export const POSTAL_MAIL_UNSUBSCRIBE_SUCCESS = ' has been successfully unsubscribed from postal mail.'
  + ' Please allow 6-8 weeks for this process to take effect.';

export const PRO_PROMO_PENDING = 'You have requested to receive promotional text messages'
  + ' from The Home Depot but have yet to confirm. Please respond to the text message to '
  + 'complete your request or click “Resend” to receive the text message again.';
export const PRO_PENDING = 'You have requested to receive Pro Communications promotional text messages but have yet to'
  + ' confirm. Please respond to the text message to complete your request or click “Resend”'
  + ' to receive a new text message.';
export const PROMO_PENDING = 'You have requested to receive The Home Depot promotional text messages but have yet'
  + ' to confirm. Please respond to the text message to complete your request or click “Resend”'
  + ' to receive a new text message.';

export const UNSUBSCRIBE_MESSAGES = {
  PRO: PRO_MARKETING_UNSUBSCRIBE_SUCCESS,
  PROMOTIONS: HOME_DEPOT_MARKETING_UNSUBSCRIBE_SUCCESS,
  LOCAL_AD: LOCAL_AD_MARKETING_EMAIL_UNSUBSCRIBE_SUCCESS,
  SPECIAL_BUY_OF_THE_DAY: SPECIAL_BUY_MARKETING_EMAIL_UNSUBSCRIBE_SUCCESS,
  SURVEYS: SURVEY_EMAIL_UNSUBSCRIBE_SUCCESS
};

export const SUBSCRIBE_MESSAGES = {
  PRO: PRO_MARKETING_SUBSCRIBE_SUCCESS,
  PROMOTIONS: HOME_DEPOT_MARKETING_SUBSCRIBE_SUCCESS,
  LOCAL_AD: LOCAL_AD_MARKETING_EMAIL_SUBSCRIBE_SUCCESS,
  SPECIAL_BUY_OF_THE_DAY: SPECIAL_BUY_MARKETING_EMAIL_SUBSCRIBE_SUCCESS,
  SURVEYS: SURVEY_EMAIL_SUBSCRIBE_SUCCESS
};
